import { render } from "./ApprovedRequest.vue?vue&type=template&id=1f8226aa"
import script from "./ApprovedRequest.vue?vue&type=script&lang=js"
export * from "./ApprovedRequest.vue?vue&type=script&lang=js"

import "./ApprovedRequest.vue?vue&type=style&index=0&id=1f8226aa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__